/**
 * Layout Manager - handles responsive layout adjustments
 */

import { els } from '../modules/ui';

/**
 * Apply responsive layout based on viewport width
 * Toggles between table view (>768px) and card view (<=768px)
 */
export function applyResponsiveLayout(): void {
  const width = window.innerWidth || document.documentElement.clientWidth;
  const useCards = width <= 768;

  if (els.lotCardsContainer) {
    if (useCards) {
      els.lotCardsContainer.removeAttribute('hidden');
    } else {
      els.lotCardsContainer.setAttribute('hidden', 'true');
    }
  }

  const tableWrap = document.querySelector('.table-wrap');
  if (tableWrap instanceof HTMLElement) {
    if (useCards) {
      tableWrap.setAttribute('hidden', 'true');
    } else {
      tableWrap.removeAttribute('hidden');
    }
  }
}

/**
 * Initialize responsive layout handling
 * Sets up initial layout and window resize listener
 */
export function initializeLayoutManager(): void {
  applyResponsiveLayout();
  window.addEventListener('resize', () => {
    applyResponsiveLayout();
  });
}
